/**
 * @fileoverview Creates query statements
 */
import { IvsFragments } from './ivs-api.fragments.js';
import { QueryType } from './ivs-api.constants.js';
/**
 * Generate an exchangeTradedFund query
 */
export const etfDataQuery = (fragments = IvsFragments.etfData) => `
  query etfData($ticker: String!) {
    exchangeTradedFund(ticker: $ticker) {
      ${fragments}
    }
  }
`;
/**
 * Get the list of all exchangeTradedFunds
 */
export const allETFsQuery = (fragments = IvsFragments.allETFs) => `
  query AllEtfs {
    allExchangeTradedFunds {
      ${fragments}
    }
  }
`;
/**
 * Generates a graphql query for Introspection data
 */
export const makeQuery = (fragment, query = QueryType.ALL) => {
    if (query === QueryType.ALL) {
        return allETFsQuery(fragment);
    }
    return etfDataQuery(fragment);
};
//# sourceMappingURL=ivs-api.queries.js.map